<template>
  <nav class="navbar-treid py-5 h-100">
    <ul class="pl-0">
      <li class="my-2 mx-2 text-center">
        <h3 class="text-center pb-4">Admin Panel</h3>
      </li>
      <li class="my-2 mx-2">
        <router-link class="btn btn-treid px-5 btn-block" to="/admin"
          >Info. general</router-link
        >
      </li>
      <li class="my-2 mx-2">
        <router-link class="btn btn-treid px-5 btn-block" to="/admin/categories"
          >Categorias</router-link
        >
      </li>
      <li class="my-2 mx-2">
        <router-link class="btn btn-treid px-5 btn-block" to="/admin/specs"
          >Especificaciones</router-link
        >
      </li>
      <li class="my-2 mx-2">
        <router-link class="btn btn-treid px-5 btn-block" to="/admin/products"
          >Productos</router-link
        >
      </li>
      <li class="my-2 mx-2">
        <router-link class="btn btn-treid px-5 btn-block" to="/admin/services"
          >Servicios</router-link
        >
      </li>
      <li class="my-2 mx-2">
        <router-link class="btn btn-treid px-5 btn-block" to="/admin/ventas"
          >Ventas</router-link
        >
      </li>
      <li class="my-2 mx-2">
        <router-link
          class="btn btn-treid px-5 btn-block"
          to="/admin/transacciones"
          >Transacciones</router-link
        >
      </li>
      <li class="my-2 mx-2">
        <router-link class="btn btn-treid px-5 btn-block" to="/admin/back-up"
          >Backup</router-link
        >
      </li>
      <li class="my-2 mx-2">
        <router-link class="btn btn-treid px-5 btn-block" to="/admin/tyc"
          >TYC</router-link
        >
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "NavbarAdmin",
  data() {
    return {};
  },
  methods: {},
  created: function() {},
};
</script>
